// extracted by mini-css-extract-plugin
export default {"placeholderWrapper":"DnU4i","wrapper":"tQCMx"};